window.Recommendation = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            ids: {
                recommendationSectionActionIds: '#recommendationSectionActionIds'
            }
        },
        gtm: {
            events: {
                nbaCardSeen: 'nbaCardSeen',
                nbaCardClicked: 'nbaCardClicked'
            }
        },
        func: {
            onloadRecommendationSection: function () {
                let eventObject = {
                    'event': self.gtm.events.nbaCardSeen,
                    'actionCD': document.querySelector(self.elements.ids.recommendationSectionActionIds).value
                };

                self.func.pushGADataLayer(eventObject);
            },
            onclickRecommendationCard: function (actionId) {
                let eventObject = {
                    'event': self.gtm.events.nbaCardClicked,
                    'actionCD': actionId
                };

                self.func.pushGADataLayer(eventObject);
                return true;
            },
            pushGADataLayer: function (eventObject) {
                window.dataLayer.push(eventObject);
            }
        }
    };

    return {
        onloadRecommendationSection: self.func.onloadRecommendationSection,
        onclickRecommendationCard: self.func.onclickRecommendationCard
    };
})();

$('document').ready(function () {
    if (window.Utilities.func.isComponentWithName('RecommendationSection')) {
        window.Recommendation.onloadRecommendationSection();
    }
});
